import http from '@/utils/http' //引入axios
export const getErrorCord = data => http.get('/maintenance-center/api/errorrecord', {
    params: data
}) //查找故障類型
export const updataErrorCord = data => http.put('/maintenance-center/api/errorrecord', data) //編輯故障類型
// export  const addErrorCord= data=>http.post('/maintenance-center/api/errorrecord',data) //添加故障類型
export const deleteErrorCord = data => http.delete('/maintenance-center/api/errorrecord', {
    params: data
}) //刪除故障類型
export const getUser = () => http.get('/user-center/api/user/dept/finduser') //获得维修人员数据
export const exportCord = data => http.get('/maintenance-center/api/errorrecord/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getErrorCord,
    updataErrorCord,
    // addErrorCord,
    deleteErrorCord,
    getUser,
    exportCord
    // findBarcode
}